import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { createPinia } from 'pinia';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
import 'bootstrap/dist/js/bootstrap.bundle';
import "bootstrap/dist/js/bootstrap.min.js";
import "./assets/scss/app.scss";

import VueFeather from "vue-feather";

import en from "@/core/locales/en.json";
import th from "@/core/locales/th.json";

import { createI18n, I18nOptions } from 'vue-i18n';

// Define the messages object explicitly
// const messages: I18nOptions['messages'] = {
//     en: en,
//     th: th,
// };

const i18n = createI18n({
    legacy: false,
    locale: 'en',
    // messages: messages,
});

createApp(App)
    .use(router)
    .use(createPinia())
    .use(i18n)
    .component(VueFeather.name || 'VueFeather', VueFeather)
    .mount('#app');
